var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "left_tree" },
        [
          _c(
            "a-spin",
            {
              staticStyle: { height: "100%" },
              attrs: { spinning: _vm.treeSpin },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { margin: "0 3px 10px 0" },
                      on: { click: _vm.syncDeptData },
                    },
                    [_vm._v("同步部门数据")]
                  ),
                  _vm.status === 1 || _vm.status === 0
                    ? _c(
                        "vxe-button",
                        {
                          staticStyle: { margin: "0 3px 10px 0" },
                          on: { click: _vm.setDeptRegion },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.status === 1 ? "取消大区" : "设置大区") +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.status === 2 || _vm.status === 0
                    ? _c(
                        "vxe-button",
                        {
                          staticStyle: { margin: "0 0 10px 0" },
                          on: { click: _vm.showDeptDealer },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.status === 2 ? "取消经销商" : "设置经销商"
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("vxe-button", { on: { click: _vm.download } }, [
                    _vm._v("下载模板"),
                  ]),
                  _c(
                    "a-upload",
                    {
                      staticStyle: { margin: "0 0 0 3px" },
                      attrs: {
                        name: "file",
                        multiple: false,
                        accept: ".xlsx",
                        action: _vm.api.comm.UPLOAD,
                        headers: { token: _vm.token },
                        showUploadList: false,
                      },
                      on: { change: _vm.handleChange },
                    },
                    [_c("vxe-button", [_vm._v("导入")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tree",
                {
                  attrs: {
                    "show-icon": true,
                    checkStrictly: true,
                    defaultExpandAll: false,
                    defaultExpandParent: true,
                    expandedKeys: _vm.defaultExpandedKeys,
                    "tree-data": _vm.deptList,
                    selectedKeys: _vm.selectedKeys,
                    replaceFields: {
                      children: "children",
                      title: "deptName",
                      key: "deptId",
                      value: "deptId",
                    },
                  },
                  on: {
                    "update:expandedKeys": function ($event) {
                      _vm.defaultExpandedKeys = $event
                    },
                    "update:expanded-keys": function ($event) {
                      _vm.defaultExpandedKeys = $event
                    },
                    select: _vm.onSelect,
                    check: _vm.onCheck,
                  },
                },
                [
                  _c("a-icon", {
                    staticStyle: { color: "#2fcfeb" },
                    attrs: { slot: "dealer", type: "team" },
                    slot: "dealer",
                  }),
                  _c("a-icon", {
                    staticStyle: { color: "#52c41a" },
                    attrs: { slot: "region", type: "cluster" },
                    slot: "region",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right_table" },
        [
          _c("x-grid", {
            ref: "grid",
            attrs: {
              id: "formList",
              rowId: _vm.rowId,
              "pager-config": _vm.pagerConfig,
              "form-config": _vm.formConfig,
              url: _vm.url,
              columns: _vm.columns,
              "other-params": {
                deptId: _vm.deptId,
              },
              "checkbox-config": _vm.checkboxConfig,
              "toolbar-config": _vm.toolbarConfig,
              "print-config": _vm.printConfig,
              "export-config": _vm.exportConfig,
              cellClick: _vm.chooseRow,
              cellDbClick: _vm.updateRow,
            },
            on: {
              "toolbar-addData": _vm.addRow,
              "toolbar-delData": _vm.delRow,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: _vm.toolbarConfig.templatelSlots,
                  fn: function () {
                    return [
                      _c("vxe-button", { on: { click: _vm.syncUserData } }, [
                        _vm._v("同步所有用户数据"),
                      ]),
                      _c(
                        "vxe-button",
                        { on: { click: _vm.syncDeptUserData } },
                        [_vm._v("同步该部门用户数据")]
                      ),
                      _c("vxe-button", { on: { click: _vm.setRole } }, [
                        _vm._v("设置角色"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "formModal",
        { attrs: { title: "成员详情", visible: _vm.editModalVisible } },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "填写经销商编码" },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("span", { staticStyle: { color: "#f5222d" } }, [_vm._v("*")]),
          _vm._v("经销商编码: "),
          _c("a-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请填写经销商编码" },
            model: {
              value: _vm.dealerNo,
              callback: function ($$v) {
                _vm.dealerNo = $$v
              },
              expression: "dealerNo",
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择角色",
            centered: "",
            maskClosable: false,
            width: 600,
          },
          on: { ok: _vm.roleSave },
          model: {
            value: _vm.roleModalVisible,
            callback: function ($$v) {
              _vm.roleModalVisible = $$v
            },
            expression: "roleModalVisible",
          },
        },
        [
          _vm.roleModalVisible
            ? _c("div", { staticClass: "ant-row ant-form-item" }, [
                _c(
                  "div",
                  { staticClass: "ant-col ant-col-4 ant-form-item-label" },
                  [
                    _c("label", { staticClass: "ant-form-item-required" }, [
                      _vm._v("选择角色"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ant-col ant-col-18 ant-form-item-control-wrapper",
                  },
                  [
                    _c("a-select", {
                      staticStyle: { width: "300px" },
                      attrs: { options: _vm.roleOption },
                      model: {
                        value: _vm.roleId,
                        callback: function ($$v) {
                          _vm.roleId = $$v
                        },
                        expression: "roleId",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }